import { render, staticRenderFns } from "./stakeholderDetails.vue?vue&type=template&id=40828f49&scoped=true&"
import script from "./stakeholderDetails.vue?vue&type=script&lang=js&"
export * from "./stakeholderDetails.vue?vue&type=script&lang=js&"
import style0 from "./stakeholderDetails.vue?vue&type=style&index=0&id=40828f49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40828f49",
  null
  
)

export default component.exports